import { render, staticRenderFns } from "./enquiryIndustry.vue?vue&type=template&id=42962c5c&scoped=true"
import script from "./enquiryIndustry.vue?vue&type=script&lang=js"
export * from "./enquiryIndustry.vue?vue&type=script&lang=js"
import style0 from "./enquiryIndustry.vue?vue&type=style&index=0&id=42962c5c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42962c5c",
  null
  
)

export default component.exports